import AccountTreeIcon from '@material-ui/icons/AccountTree';
import ProjectCreate from './ProjectCreate';
import ProjectEdit from './ProjectEdit';
import ProjectList from './ProjectList';
import ProjectShow from './ProjectShow';

const pages = {
    list: ProjectList,
    create: ProjectCreate,
    edit: ProjectEdit,
    show: ProjectShow,
    icon: AccountTreeIcon,
};

export default pages;